import { FC, useMemo } from 'react'
import { Icon as ChakraIcon, createIcon } from '@chakra-ui/react'
import {
  ArrowLeftCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  IconProps as FeatherIconProps,
  RotateCw,
  Sliders,
  X,
  ArrowRight,
  Star,
} from 'react-feather'

export const CustomSortIcon = createIcon({
  displayName: 'CustomSortIcon',
  viewBox: '0 0 19 16',
  path: (
    <>
      <path
        fill="currentColor"
        d="M4 12.17 1.41 9.59 0 11l5 5 5-5-1.41-1.41L6 12.17V0H4v12.17ZM15 3.83l2.59 2.58L19 5l-5-5-5 5 1.41 1.41L13 3.83V16h2V3.83Z"
      />
    </>
  ),
})

type AvailableIcons =
  | 'reload'
  | 'close'
  | 'chevron-left'
  | 'chevron-right'
  | 'slider'
  | 'chevron-up'
  | 'chevron-down'
  | 'arrow-left-circle'
  | 'arrow-right'
  | 'star'

export interface IconProps {
  icon: AvailableIcons
  color?: string
}

const iconMapping: Record<AvailableIcons, FC<FeatherIconProps>> = {
  reload: RotateCw,
  close: X,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  slider: Sliders,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'arrow-left-circle': ArrowLeftCircle,
  'arrow-right': ArrowRight,
  star: Star,
}

export const Icon: FC<IconProps> = ({ color = 'white', icon }) => {
  const RenderedIcon = useMemo(() => iconMapping[icon], [icon])

  return <ChakraIcon viewBox="0 0 200 200" color={color} as={RenderedIcon} />
}
